// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3BuPh","productName":"Table_productName__3DutA"};